export async function useApi<T>(
  url: string,
  options?: any
): Promise<T> {
  const config = useRuntimeConfig()

  try {
    const data = await $fetch<T>(url, {
      baseURL: config.public.apiBase,
      credentials: 'include',
      ...options,
    })

    // Изменили задачи/тендеры/календарь — сайдбар сразу пересчитывает счётчик задач
    // (Sidebar.vue следит за этим тиком), а не через минуту по таймеру
    const method = String(options?.method || 'GET').toUpperCase()
    if (method !== 'GET' && /^\/(tasks|tenders|work-calendar)(\/|$|\?)/.test(url)) {
      useState<number>('counts:tasks-changed', () => 0).value++
    }

    return data
  } catch (error: any) {
    const isNetworkError = error.name === 'FetchError' || !error.response
    const status = error.status || error.response?.status || (isNetworkError ? 0 : 500)

    if (isNetworkError) {
      console.error('Network Error:', error.message)
    } else {
      console.error('API Error:', error.status, error.data || error.message)
    }

    // Сессию завершил сервер посреди работы (сменился IP при привязке сессии к IP, вход с
    // другого устройства) — сразу на вход с объяснением, а не поток ошибок до перезагрузки
    const code = (error.data || error.response?._data)?.code
    if (status === 401 && (code === 'SESSION_IP_CHANGED' || code === 'SESSION_EXPIRED') && !url.startsWith('/auth/')) {
      useState<string | null>('auth:sessionExpired').value = code === 'SESSION_IP_CHANGED'
        ? 'Ваш IP-адрес изменился, поэтому сессия завершена. Войдите заново.'
        : 'Сессия завершена. Вы вошли с другого устройства.'
      useState('auth:user').value = null
      navigateTo('/login')
    }

    throw {
      data: error.data || error.response?._data || {
        message: isNetworkError ? 'Нет соединения с сервером' : error.message
      },
      status,
      statusText: error.statusText || error.message,
      isNetworkError,
    }
  }
}
